import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { InternalPage, PageNotFound } from 'theSource/components';
import { FamilyMemberDetails } from './components';
import { DependentsResponseDto } from '../types';
import { findDependent } from '../utils';
import { mapDependentsModel } from '../utils/mappingUtils';
import { BackLink } from 'enrollment/components';

export interface MyFamilyMemberDetailsPageProps {
  data: DependentsResponseDto;
}

export const MyFamilyMemberDetailsPage = ({
  data,
}: MyFamilyMemberDetailsPageProps) => {
  const { dependentId } = useParams();

  const dependentInfo = useMemo(
    () => findDependent(data.data.dependents, dependentId!),
    [data, dependentId]
  );

  const categories = useMemo(
    () => dependentInfo && mapDependentsModel(data, dependentInfo),
    [data, dependentInfo]
  );

  if (!categories) {
    return <PageNotFound />;
  }

  return (
    <InternalPage
      testId="family-member-details-page"
      lookupCode="enroll_dependents"
      CustomActionComponent={<BackLink />}
      customActionAlignment="left"
    >
      <FamilyMemberDetails categories={categories} />
    </InternalPage>
  );
};
